<pv-view toolbarTitle="Storage Regimes" *ngIf="regimes$ | async as regimes">

    <!-- TOOLBAR ACTIONS -->
    <div pv-view-tools>
        <button mat-icon-button (click)="addRegime(regimes)" matTooltip="Create Custom Regime" *ngIf="!isReadonly">
            <mat-icon>add</mat-icon>
        </button>
        <button mat-icon-button (click)="reload()" matTooltip="Refresh Storage Regimes">
            <mat-icon>refresh</mat-icon>
        </button>
        <button mat-icon-button (click)="clearFilters()" matTooltip="Clear Filters">
            <mat-icon>filter_alt</mat-icon>
        </button>
    </div>
    <!-- TOOLBAR ACTIONS END -->

    <!-- SIDEBAR -->
    <div pv-view-sidebar>
        <mat-tab-group>
            <mat-tab label="Filter">
                <ng-template matTabContent>
                    <form class="pv-form single-column p-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Search</mat-label>
                            <mat-icon matPrefix>search</mat-icon>
                            <input type="text" matInput [formControl]="searchControl" placeholder="Find by label">
                        </mat-form-field>
                    </form>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    <!-- SIDEBAR END -->

    <!-- FAB -->
    <button pv-view-fab mat-fab color="primary" matTooltip="Create Custom Regime" (click)="addRegime(regimes)" *ngIf="!isReadonly">
        <mat-icon>add</mat-icon>
    </button>

    <!-- PAGINATION & SORT FOOTER -->
    <div pv-view-footer class="pv-table-footer" *ngIf="indexState$ | async as indexState">
        <label class="mat-caption mr-12" for="storage_regime_index_sort">Sort</label>
        <mat-select [formControl]="columnControl"
                    id="storage_regime_index_sort"
                    class="storage-regime-index-sort-select">
            <mat-option *ngFor="let opt of indexState.sortOptions" [value]="opt.id">
                {{ opt.label }}
            </mat-option>
        </mat-select>

        <button type="button" class="ml-12" mat-icon-button (click)="toggleSortOrder($event)" matTooltip="Change Sort Direction">
            <mat-icon [svgIcon]="orderControl.value === 'asc' ? 'fa:solid-sort-alpha-up' : 'fa:solid-sort-alpha-down'">
            </mat-icon>
        </button>

        <mat-paginator [length]="indexState.total"
                       [pageIndex]="indexState.page.index"
                       [pageSize]="indexState.page.size"
                       [pageSizeOptions]="indexState.pageSizeOptions"
                       (page)="pageChange($event)">
        </mat-paginator>
    </div>
    <!-- PAGINATION & SORT FOOTER END -->

    <!-- BODY -->
    <div pv-view-body>

        <ng-container *ngIf="indexState$ | async as indexState">
        <section class="pv-storage-regime-section">

            <div class="pv-storage-regime-table pv-responsive-table" *ngIf="indexState.total > 0">
                <table cdk-table
                       [dataSource]="indexState.data"
                       matSort
                       matSortDisableClear="true"
                       [matSortActive]="indexState.sort.column"
                       [matSortDirection]="indexState.sort.order"
                       (matSortChange)="tableSortChange($event)">
                    <ng-container cdkColumnDef="label">
                        <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="label">Label</th>
                        <td cdk-cell *cdkCellDef="let regime">
                            <span class="title-line">{{ regime.config?.label }}</span>
                            <span class="caption-line" *ngIf="regime.config?.description">{{ regime.config?.description }}</span>
                        </td>
                    </ng-container>

                    <ng-container cdkColumnDef="actions">
                        <th cdk-header-cell *cdkHeaderCellDef class="no-print"></th>
                        <td cdk-cell *cdkCellDef="let regime" class="no-print">
                            <button mat-icon-button
                                    [matMenuTriggerFor]="regimeMenu"
                                    [matMenuTriggerData]="{regime: regime, regimes: regimes}"
                                    matTooltip="Regime Actions"
                                    *ngIf="!isReadonly">
                                <mat-icon>more_horiz</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <ng-container cdkColumnDef="crop">
                        <th cdk-header-cell *cdkHeaderCellDef>Crop</th>
                        <td cdk-cell *cdkCellDef="let regime">
                            <mat-icon *ngFor="let crop of regimeCrops(regime)" [svgIcon]="'common:' + crop.id" class="mat-24" matTooltip="{{ crop.label }}"></mat-icon>
                        </td>
                    </ng-container>

                    <ng-container cdkColumnDef="stages">
                        <th class="count-column" cdk-header-cell *cdkHeaderCellDef mat-sort-header="stages">Stages</th>
                        <td class="count-column" cdk-cell *cdkCellDef="let regime">{{ regime.config?.evaluations?.length || 0 }}</td>
                    </ng-container>

                    <ng-container cdkColumnDef="timestamps">
                        <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="updatedAt">Timestamps</th>
                        <td cdk-cell *cdkCellDef="let regime">
                            <span class="caption-line">Created {{ regime.createdAt | date:'mediumDate' }}</span>
                            <span class="caption-line">Updated {{ regime.updatedAt | date:'mediumDate' }}</span>
                        </td>
                    </ng-container>

                    <tr cdk-header-row *cdkHeaderRowDef="customColumns"></tr>
                    <tr cdk-row *cdkRowDef="let row; columns: customColumns;"></tr>
                </table>
            </div>

            <p *ngIf="indexState.total === 0" class="pv-storage-regime-empty">
                No custom regimes yet. Use the add button to create one.
            </p>
        </section>
        </ng-container>

        <!-- REGIME ACTIONS MENU -->
        <mat-menu #regimeMenu="matMenu">
            <ng-template matMenuContent let-regime="regime" let-regimes="regimes">
                <button mat-menu-item (click)="editRegime(regime, regimes)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                </button>
                <button mat-menu-item (click)="removeRegime(regime)">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                </button>
            </ng-template>
        </mat-menu>

    </div>
    <!-- BODY END -->

</pv-view>
